






























import Vue from 'vue';
import Component from 'vue-class-component';
import { mapGetters, mapState } from 'vuex';
import TransitionExpand from '@/components/TransitionExpand.vue';
import { getOrZero } from '@/utilities/helpers';

const Setup = Vue.extend({
	name: 'ReservationStep',
	components: {
		TransitionExpand,
	},
	props: {
		active: Boolean,
		noEdit: Boolean,
		title: String,
	},
	computed: {
		...mapState(['isLoading']),
		...mapGetters('reservation', ['isEditable']),
	},
	watch: {
		active: {
			handler(newValue: boolean) {
				if (newValue) {
					this.$nextTick(() => {
						this.scroll();
					});
				}
			},
			immediate: true,
		},
	},
	methods: {
		scroll() {
			// override
		},
	},
});

@Component
class ReservationStep extends Setup {
	// Props
	public active!: boolean;
	public noEdit!: boolean;
	public title!: string;

	// Vuex
	public isEditable!: boolean;
	public isLoading!: boolean;

	public get classes(): string[] {
		const classes: string[] = [];

		if (this.active) {
			classes.push('np-reservation__step--active');
			classes.push('np-bg-white');
		}

		classes.push(`np-reservation__step--${this.title.toLowerCase().replace(/ /g, '-')}`)

		return classes;
	}

	public get headerSize(): number {
		return +getOrZero('shortcodeAttrs.header-size', this.$store.state.reservation);
	}

	public scroll() {
		const interval = window.setInterval(() => {
			if (!this.isLoading) {
				const scroll = (this.$el as any).offsetTop - this.headerSize;
				if (scroll > 0) {
					if (!window.scroll) {
						const scrollTo = (window.scrollTo as any);
						scrollTo(this.$el, scroll, 1000);
					} else {
						window.scroll({
							top: scroll,
							behavior: 'smooth',
						});
					}
				}
				clearInterval(interval);
			}
		}, 500);
	}
}

export default ReservationStep;
